export enum BetaFeature {
  PORTFOLIO_ANALYSIS = 'portfolioAnalysis',
  PRICING = 'PRICING',
}
